import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'

import { useOutsideClick, useSetState } from '@campaignhub/react-hooks'

import Link from './Link'
import defaultStyles from './styles.scss'

const defaultState = {
  expanded: false,
}

const NavigationLinkGroup = (props) => {
  const {
    link: {
      href,
      icon,
      iconComponent,
      items,
      linkProps,
      linkTag,
      onClick,
      title,
      visible,
    },
    secondaryNav,
    sidebarMaximized,
    styles,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { expanded } = state

  const contentEl = useRef()
  const [isClickedOutside, setIsClickedOutside] = useOutsideClick(contentEl, { enabled: expanded })

  useEffect(() => {
    if (isClickedOutside){
      if (expanded) setState({ expanded: false })
      setIsClickedOutside(false)
    }
  }, [isClickedOutside, expanded])

  // Dont render if visible is false
  if (!visible) return null

  return (
    <div className={defaultStyles.root} ref={contentEl}>
      <Link
        expanded={expanded}
        hasChildren={!!items}
        href={href}
        icon={icon}
        iconComponent={iconComponent}
        linkProps={linkProps}
        linkTag={linkTag}
        onClick={
          items
            ? (e) => {
                e.preventDefault()
                e.stopPropagation()
                setState({ expanded: !expanded })
              }
            : onClick
        }
        secondaryNav={secondaryNav}
        sidebarMaximized={sidebarMaximized}
        styles={styles}
        title={title}
      />

      {sidebarMaximized &&
        expanded &&
        items &&
        items.map((item) => {
          if (item.visible) {
            return (
              <Link
                href={item.href}
                icon={item.icon}
                iconComponent={item.iconComponent}
                key={item.key}
                linkProps={linkProps}
                linkTag={linkTag}
                nested
                onClick={item.onClick}
                secondaryNav={secondaryNav}
                sidebarMaximized={sidebarMaximized}
                styles={styles}
                title={item.title}
              />
            )
          }

          return null
        })}
    </div>
  )
}

NavigationLinkGroup.propTypes = {
  link: PropTypes.shape({
    href: PropTypes.string,
    icon: PropTypes.object,
    iconComponent: PropTypes.node,
    items: PropTypes.array,
    title: PropTypes.string,
    visible: PropTypes.bool,
  }).isRequired,
  secondaryNav: PropTypes.bool,
  sidebarMaximized: PropTypes.bool,
  styles: PropTypes.object,
}

export default NavigationLinkGroup
